import axios from "../lib/axios";
import { MASTER_SUB_CATEGORIES_FIND_MANY } from "../lib/endpoints/category";
import { SuppliesProductSubCategory } from "../models/suppliesSubCategory";

export const getAllMasterSubCategory=async ():Promise<SuppliesProductSubCategory[]>=>{
  const res=await axios.post(MASTER_SUB_CATEGORIES_FIND_MANY);

  return res?.data;
}

export const getMasterSubCategory=async (categoryId:string):Promise<SuppliesProductSubCategory[]>=>{
    const res=await axios.post(MASTER_SUB_CATEGORIES_FIND_MANY,{
        "filter": {
          "supplies_product_category_id": categoryId,

        }
      });

    return res?.data;
}